import { get, post } from '@/utils/apiBase.js';

// 协议-获取协议内容-通过father_id和son_id
const getprotocalFaterSonDetail = (option) => {
  return get('/apis/admin/bottom/fater_son/detail', option);
};

// 下载用户隐私清单
const sendDownloadUserInfoRequest = (option) => {
  return post('/apis/user/down_user_info', option)
}
// 公示列表
const getRulePublicityList = option => {
  return get('/apis/admin/bottom/rule_publicity_list', option)
}
// 公示详情
const getRulePublicityDetail = option => {
  return get('/apis/admin/bottom/rule_publicity_detail', option)
}
// 帮助中心-建议与反馈
const postHelpcenterQuestionDetails = option => {
  return post('/helpcenter/question_details', option)
}
// 个人经营者资质信息
const getPersonQualificationInfo = option => {
  return get('/apis/userauth/query/person_info', option)
}

export default {
  getprotocalFaterSonDetail,
  sendDownloadUserInfoRequest,
  getRulePublicityList,
  getRulePublicityDetail,
  postHelpcenterQuestionDetails,
  getPersonQualificationInfo
};
